import { isPlatformMarketingPath } from '~/utils/marketingPaths'
import { RESERVED_SHOP_SLUGS } from '~/utils/reservedShopSlugs'
import { resolveShopSlugFromRoute } from '~/utils/resolveShopSlug'

export default defineNuxtRouteMiddleware(async (to) => {
  const domain = await ensureShopDomainResolved()

  if (isPlatformMarketingPath(to.path, Boolean(domain.shop))) {
    const normalized = to.path.replace(/\/+$/, '') || '/'
    if (normalized === '/') setPageLayout('marketing')
    return
  }

  const slug = resolveShopSlugFromRoute(
    to.path,
    to.params as Record<string, string | string[]>,
    domain.shop?.slug,
  )

  if (!slug) {
    return abortNavigation(
      createError({ statusCode: 404, statusMessage: 'Magazin invalid' }),
    )
  }

  if (RESERVED_SHOP_SLUGS.has(slug) && !domain.shop) {
    return abortNavigation(
      createError({ statusCode: 404, statusMessage: 'Magazin invalid' }),
    )
  }

  // Re-bind auth/cart after domain resolve — store init may have run before Host→shop was known
  if (import.meta.client) {
    const previousShop = useState<string>('last-bound-shop-slug', () => '')
    if (previousShop.value && previousShop.value !== slug) {
      useProductsStore().clearCatalog()
      useSiteSettings().resetForShopChange()
    }
    previousShop.value = slug

    useAuthStore().hydrateFromStorage()
    useCartStore().hydrateFromStorage()
  }
})
